import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin, Award, Users, Calendar, CheckCircle2, Mail, Phone, Globe, Filter, Search, ArrowLeft, Building2, Clock, Shield, Target } from 'lucide-react';
import { motion } from 'framer-motion';

// Top contractor verileri
const topContractors = [
  {
    id: 1,
    name: "ExpoMaster International",
    city: "Istanbul",
    country: "Türkiye", 
    rating: 4.9,
    reviews: 127,
    completedProjects: 450,
    yearsExperience: 15,
    specialties: ["Custom Design", "Luxury Stands", "Tech Integration", "Automotive"],
    description: "İstanbul'un en deneyimli fuar standı contractor'ı. CNR Expo ve Tüyap'ta 450+ başarılı proje.",
    image: "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "€300-800/m²",
    badges: ["Top Rated", "Premium Partner", "ISO Certified"]
  },
  {
    id: 2,
    name: "Dubai Elite Exhibitions",
    city: "Dubai", 
    country: "UAE",
    rating: 4.8,
    reviews: 89,
    completedProjects: 320,
    yearsExperience: 12,
    specialties: ["Luxury Design", "VIP Lounges", "LED Technology", "Fashion"],
    description: "Dubai'nin lüks segment contractor'ı. DWTC ve Sands Expo'da premium projeler.",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "$400-1200/m²",
    badges: ["Luxury Specialist", "VIP Partner", "Award Winner"]
  },
  {
    id: 3,
    name: "London Exhibition Masters",
    city: "London",
    country: "United Kingdom", 
    rating: 4.9,
    reviews: 156,
    completedProjects: 280,
    yearsExperience: 18,
    specialties: ["Sustainable Design", "Tech Stands", "Modular Systems", "FinTech"],
    description: "London'da çevre dostu ve teknolojik stand çözümlerinde uzman contractor.",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "£250-750/m²",
    badges: ["Eco Certified", "Tech Leader", "Premium Quality"]
  },
  {
    id: 4,
    name: "Parisian Excellence Design",
    city: "Paris",
    country: "France",
    rating: 4.7,
    reviews: 94,
    completedProjects: 380,
    yearsExperience: 20,
    specialties: ["French Elegance", "Fashion Stands", "Luxury Brands", "Art Integration"],
    description: "Paris'in haute couture kalitesinde stand tasarımında 20 yıllık deneyim.",
    image: "https://images.unsplash.com/photo-1657057611558-a7ecf6323aff?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "€350-1000/m²",
    badges: ["French Heritage", "Luxury Expert", "Savoir-Faire"]
  },
  {
    id: 5,
    name: "Vegas Spectacular Stands",
    city: "Las Vegas",
    country: "United States",
    rating: 4.6,
    reviews: 73,
    completedProjects: 195,
    yearsExperience: 10,
    specialties: ["Entertainment Tech", "LED Spectaculars", "Interactive Displays", "Gaming"],
    description: "Las Vegas showbiz kalitesinde gösterişli ve teknolojik stand çözümleri.",
    image: "https://images.unsplash.com/photo-1755875341396-cdbd4698912e?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "$350-950/m²",
    badges: ["Vegas Showman", "Tech Pioneer", "Entertainment Pro"]
  },
  {
    id: 6,
    name: "Beijing Modern Exhibitions",
    city: "Beijing",
    country: "China",
    rating: 4.5,
    reviews: 112,
    completedProjects: 340,
    yearsExperience: 12,
    specialties: ["Modern Chinese", "Auto Stands", "Tech Exhibitions", "Cost Effective"],
    description: "Beijing'de modern tasarım ve competitive pricing ile kaliteli hizmet.",
    image: "https://images.unsplash.com/photo-1708660575990-101db3b00294?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "¥1200-3500/m²",
    badges: ["Best Value", "Quality Assured", "Fast Delivery"]
  },
  {
    id: 7,
    name: "Euro Stands Professional",
    city: "Istanbul",
    country: "Türkiye",
    rating: 4.4,
    reviews: 67,
    completedProjects: 220,
    yearsExperience: 8,
    specialties: ["European Standards", "Modular Design", "Quick Setup", "Budget Friendly"],
    description: "Avrupa kalite standartlarında hızlı ve ekonomik stand çözümleri.",
    image: "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "€200-500/m²",
    badges: ["Budget Friendly", "Quick Setup", "EU Standards"]
  },
  {
    id: 8,
    name: "Gulf Premium Contractors",
    city: "Dubai",
    country: "UAE", 
    rating: 4.6,
    reviews: 51,
    completedProjects: 180,
    yearsExperience: 9,
    specialties: ["Premium Materials", "Gold Accents", "VIP Experience", "Hospitality"],
    description: "Dubai'de premium malzemeler ve VIP hizmet kalitesi ile öne çıkan contractor.",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "$500-1500/m²",
    badges: ["Ultra Premium", "VIP Service", "Gold Standard"]
  },
  {
    id: 9,
    name: "British Craft Exhibitions",
    city: "London",
    country: "United Kingdom",
    rating: 4.7,
    reviews: 83,
    completedProjects: 165,
    yearsExperience: 14,
    specialties: ["British Craftsmanship", "Heritage Design", "Sustainable Materials", "Innovation"],
    description: "İngiliz zanaat geleneği ile modern inovasyonu birleştiren contractor.",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "£300-900/m²",
    badges: ["Heritage Quality", "Sustainable Leader", "Innovation Award"]
  },
  {
    id: 10,
    name: "Continental Expo Solutions", 
    city: "Paris",
    country: "France",
    rating: 4.5,
    reviews: 76,
    completedProjects: 210,
    yearsExperience: 11,
    specialties: ["Continental Style", "Wine & Food", "Cultural Events", "Artistic Touches"],
    description: "Avrupa kıtası tarzında kültürel ve sanatsal dokunuşlarla öne çıkan firma.",
    image: "https://images.unsplash.com/photo-1657057611558-a7ecf6323aff?q=80&w=400&auto=format&fit=crop",
    portfolio: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=300&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=300&auto=format&fit=crop"
    ],
    price: "€280-700/m²",
    badges: ["Cultural Expert", "Artistic Touch", "Continental Style"]
  }
];

export default function Top10Contractors() {
  const [filteredContractors, setFilteredContractors] = useState(topContractors);
  const [selectedCity, setSelectedCity] = useState('all');
  const [selectedSpecialty, setSelectedSpecialty] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('rating');

  // Filtreleme ve arama
  React.useEffect(() => {
    let filtered = topContractors;

    // Şehir filtresi
    if (selectedCity !== 'all') {
      filtered = filtered.filter(contractor => contractor.city === selectedCity);
    }

    // Uzmanlık filtresi
    if (selectedSpecialty !== 'all') {
      filtered = filtered.filter(contractor => 
        contractor.specialties.some(specialty => 
          specialty.toLowerCase().includes(selectedSpecialty.toLowerCase())
        )
      );
    }

    // Arama
    if (searchTerm) {
      filtered = filtered.filter(contractor =>
        contractor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        contractor.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Sıralama
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'rating':
          return b.rating - a.rating;
        case 'projects':
          return b.completedProjects - a.completedProjects;
        case 'experience':
          return b.yearsExperience - a.yearsExperience;
        default:
          return 0;
      }
    });

    setFilteredContractors(filtered);
  }, [selectedCity, selectedSpecialty, searchTerm, sortBy]);

  const cities = [...new Set(topContractors.map(c => c.city))];
  const specialties = [...new Set(topContractors.flatMap(c => c.specialties))];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* HEADER */}
      <header className="bg-white px-6 py-4 relative z-50 border-b border-slate-200">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <img 
              src="https://boothshop.my.canva.site/master-file/images/f240dd7de334359f1526183865a27145.svg" 
              alt="EXPO STAND Logo" 
              className="w-12 h-10" 
            />
            <div className="text-slate-700">
              <div className="text-xl font-semibold leading-tight">EXPO</div>
              <div className="text-xl font-semibold leading-tight">STAND</div>
            </div>
          </a>
          
          {/* Back Button */}
          <a 
            href="/" 
            className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Ana Sayfaya Dön
          </a>
        </div>
      </header>

      {/* HERO SECTION */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-16">
        <div className="mx-auto max-w-7xl px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Top 10 <span className="text-blue-600">Contractor</span>
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto mb-8">
              Dünya genelinde en yüksek rating'li ve deneyimli fuar standı contractor'ları keşfedin
            </p>
            
            {/* İstatistikler */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="text-2xl font-bold text-blue-600 mb-1">2,650+</div>
                <div className="text-sm text-slate-600">Tamamlanan Proje</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="text-2xl font-bold text-green-600 mb-1">4.7</div>
                <div className="text-sm text-slate-600">Ortalama Rating</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="text-2xl font-bold text-purple-600 mb-1">13.4</div>
                <div className="text-sm text-slate-600">Yıl Deneyim Ort.</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="text-2xl font-bold text-orange-600 mb-1">6</div>
                <div className="text-sm text-slate-600">Şehir</div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* FİLTRELER */}
      <section className="bg-white border-b border-slate-200 py-6">
        <div className="mx-auto max-w-7xl px-6">
          <div className="flex flex-wrap items-center gap-4">
            {/* Arama */}
            <div className="relative flex-1 min-w-[300px]">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input
                type="text"
                placeholder="Contractor ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 w-full border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            {/* Şehir Filtresi */}
            <select
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              className="px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="all">Tüm Şehirler</option>
              {cities.map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
            
            {/* Uzmanlık Filtresi */}
            <select
              value={selectedSpecialty}
              onChange={(e) => setSelectedSpecialty(e.target.value)}
              className="px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="all">Tüm Uzmanlıklar</option>
              {specialties.map(specialty => (
                <option key={specialty} value={specialty}>{specialty}</option>
              ))}
            </select>
            
            {/* Sıralama */}
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="rating">Rating'e Göre</option>
              <option value="projects">Proje Sayısına Göre</option>
              <option value="experience">Deneyime Göre</option>
            </select>
          </div>
        </div>
      </section>

      {/* CONTRACTOR LİSTESİ */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {filteredContractors.map((contractor, index) => (
              <motion.div
                key={contractor.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                {/* Contractor Header */}
                <div className="relative h-48">
                  <img
                    src={contractor.image}
                    alt={contractor.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4">
                    <div className="bg-white px-3 py-1 rounded-full text-sm font-bold text-blue-600">
                      #{index + 1}
                    </div>
                  </div>
                  <div className="absolute top-4 right-4 flex gap-2">
                    {contractor.badges.slice(0, 2).map((badge, i) => (
                      <span key={i} className="bg-blue-600 text-white px-2 py-1 rounded-full text-xs font-semibold">
                        {badge}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="p-6">
                  {/* Contractor Bilgileri */}
                  <div className="mb-4">
                    <h3 className="text-xl font-bold text-slate-900 mb-2">{contractor.name}</h3>
                    <div className="flex items-center gap-2 text-slate-600 mb-2">
                      <MapPin className="h-4 w-4" />
                      <span>{contractor.city}, {contractor.country}</span>
                    </div>
                    <p className="text-slate-600 text-sm leading-relaxed">{contractor.description}</p>
                  </div>

                  {/* Rating ve İstatistikler */}
                  <div className="grid grid-cols-3 gap-4 mb-4 p-4 bg-slate-50 rounded-xl">
                    <div className="text-center">
                      <div className="flex items-center justify-center gap-1 mb-1">
                        <Star className="h-4 w-4 text-yellow-400 fill-current" />
                        <span className="font-bold text-slate-900">{contractor.rating}</span>
                      </div>
                      <div className="text-xs text-slate-500">{contractor.reviews} reviews</div>
                    </div>
                    <div className="text-center">
                      <div className="font-bold text-slate-900 mb-1">{contractor.completedProjects}</div>
                      <div className="text-xs text-slate-500">Projects</div>
                    </div>
                    <div className="text-center">
                      <div className="font-bold text-slate-900 mb-1">{contractor.yearsExperience}Y</div>
                      <div className="text-xs text-slate-500">Experience</div>
                    </div>
                  </div>

                  {/* Uzmanlıklar */}
                  <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                      {contractor.specialties.slice(0, 4).map((specialty, i) => (
                        <span key={i} className="bg-blue-100 text-blue-700 px-2 py-1 rounded-lg text-xs font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Fiyat ve Buton */}
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-lg font-bold text-slate-900">{contractor.price}</div>
                      <div className="text-xs text-slate-500">Starting price per m²</div>
                    </div>
                    <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl font-semibold transition-colors">
                      Teklif Al
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {filteredContractors.length === 0 && (
            <div className="text-center py-16">
              <Building2 className="h-16 w-16 text-slate-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-slate-700 mb-2">Contractor bulunamadı</h3>
              <p className="text-slate-500">Arama kriterlerinizi değiştirip tekrar deneyin.</p>
            </div>
          )}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-slate-900 text-white py-12">
        <div className="mx-auto max-w-7xl px-6">
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 text-xl font-bold mb-4">
              <Building2 className="h-6 w-6" />
              <span>ExpoStand - Top 10 Contractors</span>
            </div>
            <p className="text-slate-400">
              Dünya genelinde en iyi fuar standı contractor'larına ulaşın
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}